'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _math = require('./math');

var _exponentialMovingAverage = require('./exponentialMovingAverage');

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var paddingLeft = function paddingLeft(data, length) {
    var arr = [];
    arr.length = length - data.length;
    arr.fill(0);
    return [].concat(arr, _toConsumableArray(data));
};

var macdArray = function macdArray(data, config) {
    var field = config.field,
        _config$fastEmaPeriod = config.fastEmaPeriod,
        fastEmaPeriod = _config$fastEmaPeriod === undefined ? 12 : _config$fastEmaPeriod,
        _config$slowEmaPeriod = config.slowEmaPeriod,
        slowEmaPeriod = _config$slowEmaPeriod === undefined ? 26 : _config$slowEmaPeriod,
        _config$signalEmaPeri = config.signalEmaPeriod,
        signalEmaPeriod = _config$signalEmaPeri === undefined ? 9 : _config$signalEmaPeri,
        _config$pipSize = config.pipSize,
        pipSize = _config$pipSize === undefined ? 2 : _config$pipSize;


    var vals = (0, _math.takeField)(data, field);

    var length = vals.length;

    var fastEmaArray = paddingLeft((0, _exponentialMovingAverage.exponentialMovingAverageArray)(vals, { periods: fastEmaPeriod, pipSize: 20, field: field
        // -------------------------- ^ set pipSize to 20 to prevent rounding
    }), length);
    var slowEmaArray = paddingLeft((0, _exponentialMovingAverage.exponentialMovingAverageArray)(vals, { periods: slowEmaPeriod, pipSize: 20, field: field }), length);

    var macdCalcArray = paddingLeft(slowEmaArray.map(function (x, i) {
        return +(fastEmaArray[i] - x).toFixed(pipSize);
    }), length);

    var signalEmaArray = paddingLeft((0, _exponentialMovingAverage.exponentialMovingAverageArray)(macdCalcArray.slice(slowEmaPeriod - 1), { periods: signalEmaPeriod, pipSize: 20, field: field }), length);

    return macdCalcArray.map(function (x, i) {
        return [+(x - signalEmaArray[i]).toFixed(pipSize), x, +signalEmaArray[i].toFixed(pipSize)];
    }).slice(slowEmaPeriod + signalEmaPeriod - 2);
};

exports.default = macdArray;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@binary-com/binary-indicators/lib/macd.js
// module id = 499
// module chunks = 0